import React from 'react';
import { Box, ThemeUIStyleObject } from 'theme-ui';

type Props = {
  current: number;
  pages: Array<number | null>;
  onSelect: (page: number) => void;
};

const styles: Record<string, ThemeUIStyleObject> = {
  main: {
    marginLeft: 3,
    display: 'flex',
    '&::before': {
      content: '"["',
      marginRight: 1,
    },
    '&::after': {
      content: '"]"',
      marginLeft: 1,
    },
    '& > :not(:last-child)': {
      marginRight: 1,
    },
  },
  page: {
    cursor: 'pointer',
  },
  activePage: {
    textDecoration: 'underline',
    fontWeight: 700,
    pointerEvents: 'none',
    color: 'primary',
  },
  filler: {
    pointerEvents: 'none',
  },
};

const PaginationComponent: React.FC<Props> = ({ current, onSelect, pages }) => {
  return (
    <Box sx={styles.main}>
      {pages.map((page, index) => {
        return page ? (
          <Box
            key={index}
            sx={
              current === page
                ? { ...styles.page, ...styles.activePage }
                : styles.page
            }
            onClick={() => onSelect(page)}>
            {page}
          </Box>
        ) : (
          <Box key={index} sx={styles.filler}>
            ...
          </Box>
        );
      })}
    </Box>
  );
};

export default PaginationComponent;
